import React, { useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import product23 from 'assets/img/products/23.png';
import Lightbox from 'components/base/LightBox';
import useLightbox from 'hooks/useLightbox';
import { ProductSpc } from 'api/products/_requests';
import SpecificationTable from 'components/tables/SpecificationTable';

interface ProductDetail {
  keyFeature: string;
  description: string;
  specification: ProductSpc[];
  inBox: string[];
}

const ProductDetailLists = ({
  keyFeature,
  specification,
  inBox,
  description
}: ProductDetail) => {
  const { lightboxProps, openLightbox } = useLightbox([product23]);
  const [expanded, setExpanded] = useState(false);

  return (
    <Card className="p-3 p-lg-4">
      <Row className="gy-3">
        <Col xs={12}>
          <h4 className="mb-2 text-body-emphasis">About This Product</h4>
        </Col>
        <Col xs={12} className="border-top border-translucent pt-3">
          <h4 className="mb-3">Key Features</h4>
          <div dangerouslySetInnerHTML={{ __html: keyFeature }} />
        </Col>

        <Col xs={12} className="border-top border-translucent pt-3">
          <h4 className="mb-3">Product Specifications</h4>
          <SpecificationTable
            title="More simple explantion"
            data={specification || []}
            inBox={inBox || []}
          />
        </Col>

        <Col xs={12} className="border-top border-translucent pt-3">
          <h4 className="mb-2 text-body-emphasis">Description</h4>

          <div
            className={`mb-2 ${!expanded ? 'line-clamp' : ''}`}
            style={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: !expanded ? 5 : 'unset'
            }}
            dangerouslySetInnerHTML={{ __html: description }}
          />

          <button
            type="button"
            className="btn btn-link p-0 fw-semibold"
            onClick={() => setExpanded(!expanded)}
          >
            {expanded ? 'Show less' : 'See more'}
          </button>
        </Col>
      </Row>
    </Card>
  );
};

export default ProductDetailLists;
